import { Card, CardContent, Modal, Typography, Box } from "@mui/material";
import { ListDivider } from "../../ui/ListStyles";
import FavoritesSearch from "../search/FavoritesSearch";
import { useSearchParams } from "react-router-dom";
import FavoriteContainer from "./FavoriteContainer";
import NotFound from "../notfound/NotFound";
import Loading from "../loader/Loading";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "90%", md: "60%", lg: "50%" },
  outline: "none",
  borderRadius: "12px",
};

const Favorites = ({
  isOpen,
  handleClose,
  favorites,
  handleSelectedFavorite,
  handleDeleteFavorite,
  FavoriteCard,
  isChartLoading,
}) => {
  const [searchParams] = useSearchParams();

  const currentQuery = searchParams.get("fav_query") || "";

  return (
    <Modal open={isOpen} onClose={handleClose}>
      <Box sx={style}>
        <Card>
          <CardContent
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "14px",
              height: "70vh",
            }}
          >
            <Box
              sx={{
                display: "flex",
                gap: "14px",
                flexDirection: { xs: "column", md: "row" },
                justifyContent: { xs: "center", md: "space-between" },
                alignItems: "center",
              }}
            >
              <Typography sx={{ fontSize: "20px", fontWeight: 700 }}>
                علاقمندی‌ها
              </Typography>

              <FavoritesSearch width={{ xs: "100%", md: "300px" }} />
            </Box>

            <ListDivider />

            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                overflowY: "auto",
                height: "70vh",
              }}
            >
              {isChartLoading ? (
                <Loading />
              ) : favorites &&
                favorites
                  .slice()
                  .reverse()
                  .filter(
                    (item) =>
                      item &&
                      Object.values(item).some(
                        (value) =>
                          value &&
                          value
                            .toString()
                            .toLowerCase()
                            .startsWith(currentQuery.toLowerCase())
                      )
                  ).length > 0 ? (
                favorites
                  .slice()
                  .reverse()
                  .filter(
                    (item) =>
                      item &&
                      Object.values(item).some(
                        (value) =>
                          value &&
                          value
                            .toString()
                            .toLowerCase()
                            .startsWith(currentQuery.toLowerCase())
                      )
                  )
                  .map((favorite) => (
                    <FavoriteContainer
                      key={favorite.id}
                      favorite={favorite}
                      handleSelectedFavorite={handleSelectedFavorite}
                      handleDeleteFavorite={handleDeleteFavorite}
                    >
                      <FavoriteCard favorite={favorite} />
                    </FavoriteContainer>
                  ))
              ) : (
                <NotFound />
              )}
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Modal>
  );
};

export default Favorites;
